/** @format */

import styled from "styled-components";
import zeusLogoImg from "../../images/zeus_color_white.png";
import bcartLogoImg from "../../images/bcart_logo.png";
import { mixins, fonts, colors } from "../../css/variables";
import { Menu } from "../ui-parts";
import createImg from "../../images/icon_create_inquiry.svg";

const StyledHeader = styled.header`
  position: sticky;
  z-index: 900;
  top: 0;
  background: ${colors.themeColor("background_main")};
`;
const HeaderBar = styled.div`
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 62px;
  border-bottom: 2px solid ${colors.themeColor("primary")};
`;
const TitleLogo = styled.div`
  display: flex;
  align-items: center;
`;

const DisplayLogo = styled.img<{ zAccount?: string }>`
  width: ${({ zAccount }) => (zAccount === "bcart" ? "150px" : "104px")};
  margin-right: 24px;
  display: block;
  ${mixins.screenUnder()} {
    width: ${({ zAccount }) => (zAccount === "bcart" ? "108px" : "78px")};
    margin-right: 8px;
  }
`;

const TitleText = styled.div`
  font-size: ${fonts.fontSizeRem("m")};
  font-weight: bold;
  ${mixins.screenOver()} {
    padding-left: 24px;
    border-left: 1px solid ${colors.themeColor("border_box")};
  }
  ${mixins.screenUnder(767)} {
    font-size: ${fonts.fontSizeRem("xs")};
  }
`;
const BreadCrumbs = styled.div`
  padding: 14px 16px;
  font-size: ${fonts.fontSizeRem("xs")};
  display: flex;
  align-items: center;
  justify-content: end;
  border-bottom: 1px solid ${colors.themeColor("border_box")};
`;

type canceledFlagType = {
  canceledFlag: boolean;
};
const CreateInquiryBtnStyle = styled.button<canceledFlagType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  background: ${(props) => (props.canceledFlag ? colors.themeColor("background_gray") : colors.themeColor("primary"))};
  padding: 4px 0;
  border-radius: 8px;
  margin-left: 16px;
  cursor: pointer;
  border: none;
`;

const CreateInquiryBtnIconStyle = styled.div`
  width: 12.15px;
  height: 12.15px;
  background: url(${createImg}) no-repeat center;
`;
const CreateInquiryBtnTextStyle = styled.div<canceledFlagType>`
  margin-left: 5.57px;
  color: ${(props) => (props.canceledFlag ? colors.themeColor("text_disabled") : colors.themeColor("text_white"))};
`;
export const Header = ({
  isLogin = false,
  isModalOpen = false,
  modalOpenHandler = () => {},
  canceledFlag = false,
  navigateByAgent,
  redirect,
  closeState = {
    confirm_flag: false,
    confirm_date: null,
  },
  agentName = "",
  path = "",
  zAccount = "",
  showClosingNoticeText = true,
}: {
  isLogin?: boolean;
  isModalOpen?: boolean;
  modalOpenHandler?: Function;
  canceledFlag?: boolean;
  navigateByAgent: Function;
  redirect?: boolean;
  closeState?: {
    confirm_flag: boolean;
    confirm_date: string | null;
  };
  agentName?: string;
  path?: string;
  zAccount?: string;
  showClosingNoticeText?: boolean;
}) => (
  <StyledHeader>
    <HeaderBar>
      <TitleLogo>
        {zAccount === "bcart" ? (
          <DisplayLogo src={bcartLogoImg} alt="Bカートクレカ決済" zAccount={zAccount} />
        ) : (
          <DisplayLogo src={zeusLogoImg} alt="株式会社ゼウス" zAccount={zAccount} />
        )}

        <TitleText className="mr24">
          Web申込システム
          {agentName}
        </TitleText>
        {isLogin && closeState.confirm_flag && showClosingNoticeText && (
          <TitleText className="display-desktop red_text">
            {closeState.confirm_date}にこちらの申し込み画面がご利用いただけなくなります。
          </TitleText>
        )}
      </TitleLogo>
      {isLogin ? <Menu navigateByAgent={navigateByAgent} redirect={redirect} path={path} /> : <></>}
    </HeaderBar>
    {isLogin ? (
      <BreadCrumbs>
        {/* ログイン後、お問い合わせモーダルが開いていない、ハンドラが定義されている。キャンセルされていない、不備画面でない、お申し込み履歴画面でない */}
        {isLogin &&
          !isModalOpen &&
          modalOpenHandler &&
          canceledFlag !== undefined &&
          path !== "/inquiry" &&
          path !== "/entry_select" && (
            <CreateInquiryBtnStyle
              onClick={() => modalOpenHandler()}
              canceledFlag={canceledFlag}
              disabled={canceledFlag}
            >
              <CreateInquiryBtnIconStyle />
              <CreateInquiryBtnTextStyle canceledFlag={canceledFlag}>お問い合わせはこちら</CreateInquiryBtnTextStyle>
            </CreateInquiryBtnStyle>
          )}
      </BreadCrumbs>
    ) : (
      <></>
    )}
  </StyledHeader>
);
